<template>
  <div class="listContent">
    <a-form :form="form" class="headForm" labelAlign="left">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="原料名称">
            <a-input v-decorator="['name']" placeholder="请输入名称" @pressEnter="getList({current:1,pageSize:pagination.pageSize})"/>
          </a-form-item>
        </a-col>
        <a-col :span="6" v-if="overseasFlag == 1">
          <a-form-item label="原料别名" >
            <a-input v-decorator="['aliasName']" placeholder="请输入原料别名" @pressEnter="getList({current:1,pageSize:pagination.pageSize})"/>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="原料类型">
            <type-list v-model="typeId" category="raw" @setVal='setVal' />
          </a-form-item>
        </a-col>

        <a-col :span="6" class="submitBtnBox">
          <a-button type="primary" class="btnMar" @click="getList">
            查询
          </a-button>
          <a-button @click="resetFields">
            清空
          </a-button>
        </a-col>
      </a-row>
    </a-form>
    <div class="editBox justifyBox">
      <div>
        <template v-for="el in menuBtnList">
          <template v-if="el.code.indexOf('third') >= 0">
            <a-button
              :key="el.id"
              :type="el.code.indexOf('add') >= 0 ? 'primary' : el.code.indexOf('delete') >= 0 ? 'danger' : ''"
              :ghost="el.code.indexOf('delete') >= 0"
              :disabled="(isDelete && el.code.indexOf('delete') >= 0) || (isEdit && el.code.indexOf('edit') >= 0)"
              @click="clickFunc(el.path,el.code)"
            >
              {{el.name}}
            </a-button>
          </template>
        </template>
        <span v-if="selectedRowKeys.length > 0" class="selectTips">
          已选中 {{ selectedRowKeys.length }} 条原料
        </span>
      </div>
      <!-- <div>
        <a-tooltip placement="top">
          <template slot="title">
            <span>原料营养指标对比</span>
          </template>
          <a-button type="primary" @click="openComparison" class="vsBtn">VS</a-button>
        </a-tooltip>
      </div> -->
    </div>
    <resize-table
      ref="listRef"
      row-key="id"
      :loading="loading"
      :columns="columns"
      :data-source="list"
      class="tableBox"
      :row-selection="rowSelection"
      :pagination="pagination"
      :scroll="{ y ,x: 500}"
      bordered
    >
    <!-- 'privateContractPrice','privateStockPrice','privateMarketPrice','privatePredictionPrice','fixRatio','minWeightVal', -->
      <template slot="customTitle">
        <a-icon
          @click="fixedCol"
          type="pushpin"
          :theme="filled ? 'filled' : 'outlined'"
        />
        原料名称
      </template>
      <template slot="name" slot-scope="t,record">
        <a-tooltip>
          <template slot="title">
            {{t}}
          </template>
          <a @click="() => getMaterial(record)"  class="nameStyle">{{t}}</a>
        </a-tooltip>
      </template>
      <template slot="rawTypeName" slot-scope="t">
        <a-tooltip>
          <template slot="title">
            {{t}}
          </template>
          {{t}}
        </a-tooltip>
      </template>
      <template slot="aliasName" slot-scope="text, record">
        <cell-editor-text
          style="width: 100%;"
          :item="record"
          name="aliasName"
          @blur="(target) => itemUpdate(target, 'aliasName')"
          :text="text"
          :actions="(e) => update(e, 'aliasName')"
          :background="true"
        />
      </template>
      <span
        :key="el"
        v-for="el in ['privateContractPrice','privateStockPrice','privateMarketPrice','privatePredictionPrice','fixRatio','minWeightVal']"
        :slot="el"
        slot-scope="text, record"
      >
        <cell-editor
          style="width: 100%;"
          :len="len(el)"
          :precision="len(el)"
          :item="record"
          :name="el"
          :min="el === 'fixRatio' || el === 'minWeightVal' ? fixMin : min"
          :max="el === 'fixRatio' || el === 'minWeightVal' ? fixMax : max"
          @blur="(target) => itemUpdate(target, el)"
          :text="text"
          :actions="(e) => update(e, el)"
          :background="true"
        />
      </span>
      <template slot="x" slot-scope="text, record">
        <a @click="() => getMaterial(record)">查看养分</a>
      </template>
    </resize-table>
    <add-material-list :visible="addVisible" @close='closeFunc' :type='modalType' :rowData='rowData' :customId='customId'/>
    <mater-drawer ref="MaterDrawer" :marterArr="selectedRows" />
    <copy-modal ref="CopyModal" />
    <comparison-nutritional :visible="comparisonVisible" @close="closeComparison" />
  </div>
</template>
<script>
import api from './api'
import CellEditor from "./CommonConponents/CellEditor.vue";

import AddMaterialList from './ModalConponents/AddMaterialList.vue'
import MaterDrawer from './ModalConponents/MaterDrawer'
import CopyModal from './ModalConponents/CopyModal.vue'
import ComparisonNutritional from './ModalConponents/ComparisonNutritional.vue'
import TypeList from '@/components/Common/components/Type.vue'
import CellEditorText from './CommonConponents/CellEditorText.vue'
import {getRequest} from '../../Common/Utils/Utils'
import { mapMutations } from 'vuex'
export default {
  props: ['btnList'],
  components: {AddMaterialList,CellEditor,MaterDrawer,CopyModal,ComparisonNutritional,TypeList,CellEditorText},
  data() {
    return {
      filled: false,
      y: 500,
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      factoryId: window.localStorage.getItem('factoryId'),
      customId: getRequest('id'),
      form: this.$form.createForm(this),
      menuBtnList: [],
      loading: false,
      fixedColumns: [
        {
          title: "原料别名",
          dataIndex: "aliasName",
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: "aliasName" },
          sorter: (a, b) => a.name.localeCompare(b.name, "zh"),
        },
        {
          title: "代码",
          dataIndex: "code",
          width: 120,
          ellipsis: true,
          sorter: (a, b) => a.code.localeCompare(b.code, "zh"),
        },
        {
          title: "类型",
          dataIndex: "rawTypeName",
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: "rawTypeName" },
          sorter: (a, b) => a.rawTypeName.localeCompare(b.rawTypeName, "zh"),
        },
        {
          title: "市场价格",
          dataIndex: "privateMarketPrice",
          align: 'center',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "privateMarketPrice" },
          sorter: (a, b) => a.privateMarketPrice - b.privateMarketPrice,
        },
        {
          title: "库存价格",
          dataIndex: "privateStockPrice",
          align: 'center',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "privateStockPrice" },
          sorter: (a, b) => a.privateStockPrice - b.privateStockPrice,
        },
        {
          title: "合同价格",
          dataIndex: "privateContractPrice",
          align: 'center',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "privateContractPrice" },
          sorter: (a, b) => a.privateContractPrice - b.privateContractPrice,
        },
        {
          title: "预测价格",
          dataIndex: "privatePredictionPrice",
          align: 'center',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "privatePredictionPrice" },
          sorter: (a, b) => a.privatePredictionPrice - b.privatePredictionPrice,
        },
        {
          title: "取整系数(KG)",
          dataIndex: "fixRatio",
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "fixRatio" },
          sorter: (a, b) => a.fixRatio - b.fixRatio,
        },
        {
          title: "最小称量量(KG)",
          dataIndex: "minWeightVal",
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "minWeightVal" },
          sorter: (a, b) => a.minWeightVal - b.minWeightVal,
        },
        {
          title: "单位",
          dataIndex: "unit",
          width: 80,
          ellipsis: true,
        },
        {
          title: "更新时间",
          dataIndex: "updateTime",
        },
        {
          title: "备注",
          dataIndex: "remark",
          width: 160,
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "x",
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: "x" },
        },
      ],
      pagination: {
        total:0,
        pageSize:20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      addVisible: false,
      editVisible: false,
      modalType: 'add',
      rowData: {},
      comparisonVisible: false,
      typeId: '',
      min: 0,
      fixMin: -9999999.999,
      max: 999999999999.999,
      fixMax: 9999999.999
    }
  },
  computed:{
    columns(){
      let list = []
      let marterialName = {
        // title: "原料名称",
        dataIndex: "name",
        width: 160,
        ellipsis: true,
        slots: { title: "customTitle" },
        scopedSlots: { customRender: "name" },
        sorter: (a, b) => a.name.localeCompare(b.name, "zh"),
      }
      if(this.filled) marterialName.fixed = 'left'
      let ls = []
      if(this.overseasFlag == 1){
        ls = [...this.fixedColumns]
      }else {
        ls = this.fixedColumns.filter(el => el.dataIndex !== 'aliasName')
      }
      list = [marterialName,...ls]
      return list
    },
    rowSelection(){
      return {
        onChange: (selectedRowKeys,selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          let arr = [...this.selectedRows, ...selectedRows]
          this.selectedRows = selectedRowKeys.map(i => {
            return arr.filter(item=>item.id === i)[0]
          })
        },
        selectedRowKeys: this.selectedRowKeys
      }
    },
    isDelete(){
      return this.selectedRowKeys.length === 0
    },
    isEdit(){
      return this.selectedRowKeys.length === 0
    },
    // min(type){
    //   let min = 0
    //   if(type === 'fixRatio' || type === 'minWeightVal') min = -9999999.999
    //   return min
    // },
    // max(type){
    //   let max = 999999999999.999
    //   if(type === 'fixRatio' || type === 'minWeightVal') max = 9999999.999
    //   return max
    // },
  },
  created(){
    this.dealBtnList(this.btnList)
    this.getList()
  },
  mounted() {
    this.y = this.$refs.listRef.$el.offsetHeight - 116
  },
  watch: {
    btnList: {       
      handler(val){
        this.dealBtnList(val)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations('material',['setState']),
    fixedCol(e) {
      this.filled = !this.filled;
      e = e || window.event;
      if (e.stopPropagation) {
        e.stopPropagation();
      } else {
        e.cancelBubble = true;
      }
    },
    setVal(val){
      if(val) {
        this.typeId = val ? val[val.length - 1] : undefined
      }else{
        this.typeId = undefined
      }
    },
    openComparison(){
      this.comparisonVisible = true
    },
    closeComparison(){
      this.comparisonVisible = false
    },
    len(){
      let len = 3
      return len
    },
    clickFunc(functionName,type){
      this[functionName](type)
    },
    synchronizeData(type){
      let str = ''
      let feild = ''
      let params
          
      if(type === 'third_edit'){
        str = '选中'
        feild = 'syncSelectRawsList'
        let ids = this.selectedRowKeys.join(',')
        params= ids
      }else{
        str = '所有'
        feild = 'syncCustomerAllRawsList'
        params = {
          customId: this.customId,
          factoryId: this.factoryId
        }
      }
      this.$confirm({
        title: `同步${str}原料`,
        content: <p>
          <span style={{color: 'red'}}>执行同步后，{str}原料的价格、取整系数、最小称量量、营养指标数值，将与工厂原料数据保持一致，</span>
          <span style={{color: 'gray'}}>你还要继续吗？</span>
        </p>,
        cancelText:'取消',
        okText:'确定',
        onOk: async () => {
          let res = await api[feild](params)
          let {success,msg} = res || {}
          this.$message[success ? 'success' : 'warning'](msg)
          this.selectedRowKeys = []
          this.selectedRows = []
          this.getList({current: 1,pageSize: this.pagination.pageSize})
        },
      })
    },
    // 新增
    addRow(){
      this.modalType = 'add'
      this.addVisible = true
    },
    // editRow(){
    //   this.modalType = 'edit'
    //   this.rowData = this.selectedRows[0] || {}
    //   // this.editVisible = true
    //   this.addVisible = true
    // },
    // 批量复制
    copyData(record){
      let data
      if(record === 'third_edit') {
        data = this.selectedRows
      }
      else {
        data = [record]
      }
      this.$refs.CopyModal.init(data)
    },
    // 多原料编辑
    editList(){
      this.setState({marterArr: this.selectedRows})
      // this.$refs.MaterialEdit.modalShow();
      setTimeout(() => {
        this.$refs.MaterDrawer.modalShow()
      }, 0);
    },
    closeFunc(feild,type){
      if(type) this.getList()
      this[feild] = false
    },
    // 删除
    deleteRow(){
      this.$confirm({
        title: '提示',
        content: '确认将选中的原料删除吗？',
        cancelText:'取消',
        okText:'确定',
        onOk: async () => {
          let ids = this.selectedRowKeys.join(',')
          let res = await api.deleteCustomerMaterialRow(ids)
          let {success,msg} = res || {}
          this.$message[success ? 'success' : 'warning'](msg)
          this.selectedRowKeys = []
          this.selectedRows = []
          this.getList({current: 1,pageSize: this.pagination.pageSize})
        },
      })
    },
    dealBtnList(val=[]){
      let menuObj = val.filter(e => e.code === "customer-management")[0] || {}
        if(menuObj && menuObj.children && menuObj.children.length){
          this.menuBtnList = menuObj.children || []
        }else{
          this.menuBtnList = []
        }
    },
    async getList(pagination) {
      const valid = await this.form.validateFields()
      this.loading = true
      let { current = 1, pageSize = 20 } = pagination || this.pagination
      let { ...newdata } = valid
      let params = {
        factoryId: this.factoryId,
        customId: this.customId,
        typeId: this.typeId ? this.typeId : undefined,
        ...newdata,
        current,
        size: pageSize
      }
      let res = await api.getCustomerMaterialList(params)
      let { success, data } = res
      if (success) {
        let { records = [], current = 1, total = 0, size = 10 } = data
        this.loading = false
        this.list = records
        this.pagination.current = current
        this.pagination.total = total
        this.pagination.pageSize = size
      }
    },
    resetFields(){
      this.typeId = undefined
      this.form.resetFields()
    },
    getMaterial(record){
      let overseasFlag = window.localStorage.getItem('overseasFlag')
      let name = overseasFlag == 1 ? (record.aliasName || record.name) : record.name
      this.$router.push(`/mainPage/customer-nutrient?name=${name}&id=${record.id}&customId=${record.customId}&isFucCal=${record.isFucCal}&rawId=${record.rawId}`)
    },
    async update(arg, field) {
      if (field === "aliasName") {
        let val = arg.aliasName;
        let reg =
          /[`~!@$^&_+=<>?:"{}|,.;'\\[\]·~！@￥……&——+={}|《》？：“”【】、；‘’，。、]/im;
        if (!reg.test(val)) {
          if (!val) arg.aliasName = null;
          arg={...arg,name:''}
          await this.$post("/nhf-custom/custfactorystaffraw/update", arg);
        } else {
          this.$message.warning("请不要输入非法字符");
        }
      } else {
        arg.aliasName = !arg.aliasName ? null : arg.aliasName
        // fixRatio,minWeightVal
        if(field === 'fixRatio' || field == 'minWeightVal'){
          if(arg[field] < 0) arg[field] = null
        }
        await this.$post("/nhf-custom/custfactorystaffraw/update", arg);
      }
      return {};
    },
    itemUpdate(item, feild) {
      let val = item[feild];
      let record = this.list.filter((el) => el.id === item.id)[0];
      if(feild === "aliasName"){
        let reg = /[`~!@$^&_+=<>?:"{}|,.;'\\[\]·~！@￥……&——+={}|《》？：“”【】、；‘’，。、]/im;
        if (!reg.test(val)) {
          record[feild] = val;
        } else {
          record[feild] = null;
        }
      }else{
        record[feild] = val;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.listContent {
  .tableBox {
    height: calc(100% - 132px);
    min-height: 240px;
  }
}
.vsBtn{
  font-size: 14px !important;
  height: 32px !important;
  margin-right: 10px;
  padding: 0px 6px;
}
</style>
